import React from 'react';

/**
 * CKD Companion brand mark — a heart with a friendly cat face (closed eyes,
 * nose, whiskers). Drop-in replacement for the old paw `PawLogo`: same export
 * name and `className` / `color` props, so existing import sites don't change.
 *
 * The face details (eyes/nose/whiskers) are drawn in `faceColor` so they read
 * against the heart fill. When the mark sits on a colored tile (e.g. a
 * `bg-sage-600` square with `color="white"`), pass `faceColor` matching the
 * tile, e.g. `<PawLogo color="white" faceColor="#6D28A8" />`. On a white/ivory
 * surface the default is fine.
 */
interface PawLogoProps {
  /** Tailwind size class, e.g. "w-5 h-5". */
  className?: string;
  /** Heart fill color. @default 'currentColor' */
  color?: string;
  /** Eye/nose/whisker color — set to the surface behind the mark. @default '#FAF7FC' */
  faceColor?: string;
}

export const PawLogo: React.FC<PawLogoProps> = ({
  className = 'w-5 h-5',
  color = 'currentColor',
  faceColor = '#FAF7FC',
}) => (
  <svg
    className={className}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M24 40 C24 40 8 29 8 18 C8 12.5 12 9 16 9 C19 9 21.8 10.8 24 14 C26.2 10.8 29 9 32 9 C36 9 40 12.5 40 18 C40 29 24 40 24 40 Z"
      fill={color}
    />
    <path
      d="M17.5 21.5 q2.3 -2.4 4.6 0 M25.9 21.5 q2.3 -2.4 4.6 0"
      stroke={faceColor}
      strokeWidth="1.7"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="24" cy="24.4" r="1.4" fill={faceColor} />
    <path
      d="M12 23.5 l5 -.3 M12.5 26.7 l4.7 -1.2 M36 23.5 l-5 -.3 M35.5 26.7 l-4.7 -1.2"
      stroke={faceColor}
      strokeWidth="1.1"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export default PawLogo;
